<mat-card class="payment-information">
    <mat-card-title>Payment Information</mat-card-title>

    <mat-tab-group [ngClass]="{ 'single-tab': !isLoginOnCheckoutEnabled() }">
        <mat-tab label="Log In" *ngIf="isLoginOnCheckoutEnabled()">
            <ng-template matTabContent>
                <ols-existing-client
                    [purchaseAgreement]="purchaseAgreement"
                    [cardsOnFile]="cardsOnFile"
                    [surchargeSettings]="stripeSurchargeSettings"
                    [isLoading]="isLoading"
                ></ols-existing-client>
            </ng-template>
        </mat-tab>
        <mat-tab label="Continue as Guest">
            <ng-template matTabContent>
                <ols-guest-client
                    [purchaseAgreement]="purchaseAgreement"
                    [isLoading]="isLoading"
                    [surchargeSettings]="stripeSurchargeSettings"
                    [summary]="summary"
                ></ols-guest-client
            ></ng-template>
        </mat-tab>
    </mat-tab-group>
</mat-card>
